import script from "./SecondBuild.vue?vue&type=script&setup=true&lang=ts"
export * from "./SecondBuild.vue?vue&type=script&setup=true&lang=ts"

import "./SecondBuild.vue?vue&type=style&index=0&id=d5acf5d8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5acf5d8"]])

export default __exports__